var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personalizedrecommendation"},[_vm._v(" "+_vm._s(_vm.datas.text)+" "),_vm._t("deles")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }